import styled from 'styled-components'

export const Container = styled.div`
  padding-top:20px;
  display:flex;
  flex-direction: column;
  gap:20px;
`